import { t } from "i18next";

import { colors } from "#app/theme/v1/colors";
import { InfoPredictedPricePopover } from "#modules/quoteRequestLines/InfoPredictedPricePopover";
import { marginPercentOfCost } from "#shared/helpers/prices";
import { Icon } from "#shared/icons/Icon";
import { Flex } from "#shared/view/components/Flex";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { Tooltip } from "#shared/view/designSystem/Tooltip";
import { formatPrice } from "shared";

export const PriceDisplay = ({
  primaryCostLabel,
  primaryCost,
  secondaryCost,
  secondaryCostLabel,
  marginPrice,
  disclaimer = false,
  condensed = false,
  isOptimized = false,
}: {
  primaryCost: number;
  primaryCostLabel: string;
  secondaryCost?: number;
  secondaryCostLabel?: string;
  marginPrice?: number;
  disclaimer?: boolean;
  condensed?: boolean;
  isOptimized?: boolean;
}) => {
  const marginPercentage = marginPercentOfCost(marginPrice, primaryCost);

  return (
    <Stack gap="0" align="flex-end">
      {!condensed && (
        <Text c="dimmed" ta="right">
          {disclaimer && <InfoPredictedPricePopover />}
          {primaryCostLabel}
        </Text>
      )}

      <Flex align="center" gap={4}>
        {isOptimized && (
          <Tooltip label={t("qrl.price.optimized")}>
            <Flex role="img" aria-label={t("qrl.price.optimized")}>
              <Icon name="stars" size={12} color={colors.blue[5]} />
            </Flex>
          </Tooltip>
        )}
        <Text fz="xl" c="violet" ta="right">
          {formatPrice(primaryCost)}
        </Text>
      </Flex>

      {!condensed && secondaryCostLabel && (
        <Text size={"10px"} c="gray.4" ta="right">
          {secondaryCostLabel}: {formatPrice(secondaryCost)}
        </Text>
      )}

      {marginPrice && (
        <Text size={"11px"} c="gray.5" ta="right" py={2}>
          {`${t("settings.materials.volumetricPrice")} : ${formatPrice(
            marginPrice,
          )} (+${marginPercentage}%)`}
        </Text>
      )}
    </Stack>
  );
};
